{
    "common": {
        "languageSelector": "Language"
    },
    "navbar": {
        "howItWorks": "How it works",
        "features": "Features",
        "pricing": "Pricing",
        "dashboard": "Dashboard",
        "logout": "Logout",
        "login": "Login",
        "createAccount": "Create account",
        "myAccount": "My account",
        "toggleMenu": "Toggle menu"
    },
    "auth": {
        "brandName": "HireFit",
        "footerTagline": "No spam. No fluff. Just results.",
        "brandPanel": {
            "headline": "We make your profile impossible to ignore.",
            "tagline": "Land your dream job with confidence",
            "body": "AI powered coaching, resume analysis and interview preparation. All in one place!",
            "resumeHint": "This could be your resume!"
        },
        "google": {
            "notConfigured": "Google Sign-In is not available in this environment yet.",
            "scriptError": "Couldn't load Google Sign-In. Check your connection and try again.",
            "dismissed": "Google Sign-In was cancelled.",
            "submitFallback": "Unable to sign in with Google. Please try again."
        },
        "login": {
            "title": "Ready for your next offer?",
            "subtitle": "Sign in to your HireFit account",
            "googleButton": "Continue with Google",
            "divider": "or sign in with email",
            "emailLabel": "Email address",
            "emailPlaceholder": "example@gmail.com",
            "passwordLabel": "Password",
            "passwordPlaceholder": "Enter your password",
            "forgotPassword": "Forgot password?",
            "showPassword": "Show password",
            "hidePassword": "Hide password",
            "submitDefault": "Log in",
            "submitLoading": "Logging in...",
            "noAccount": "Don't have an account?",
            "createAccountLink": "Create account",
            "notices": {
                "emailChanged": "Your email changed. Please sign in again.",
                "accountDeleted": "Your account has been deleted."
            },
            "errors": {
                "emailRequired": "Email is required.",
                "emailInvalid": "Please enter a valid email address.",
                "passwordRequired": "Password is required.",
                "passwordTooShort": "Password must be at least 6 characters.",
                "submitFallback": "Unable to sign in. Please check your credentials."
            }
        },
        "register": {
            "title": "Ready for your next offer?",
            "subtitle": "Create your HireFit account",
            "googleButton": "Continue with Google",
            "divider": "or sign up with email",
            "firstNameLabel": "First name",
            "lastNameLabel": "Last name",
            "emailLabel": "Email address",
            "emailPlaceholder": "example@gmail.com",
            "passwordLabel": "Password",
            "passwordPlaceholder": "Minimum 8 characters",
            "showPassword": "Show password",
            "hidePassword": "Hide password",
            "submitDefault": "Create account",
            "submitLoading": "Creating account...",
            "haveAccount": "Already have an account?",
            "signInLink": "Sign in",
            "errors": {
                "firstNameRequired": "First name is required.",
                "lastNameRequired": "Last name is required.",
                "emailRequired": "Email is required.",
                "emailInvalid": "Please enter a valid email.",
                "passwordRequired": "Password is required.",
                "passwordTooShort": "Password must be at least 8 characters.",
                "submitFallback": "Unable to create account right now."
            }
        }
    },
    "dashboard": {
        "shell": {
            "sidebar": {
                "mainNavigation": "Main navigation",
                "dashboard": "Dashboard",
                "myCvs": "My CV's",
                "myAnalysis": "My Analysis",
                "jobDescriptions": "Job Descriptions",
                "sevenDayPlan": "7 Day plan",
                "voiceNotes": "Voice notes",
                "cvRewrite": "Complete analysis",
                "realityCheck": "Reality Check",
                "jobMatches": "Job Matches",
                "jobTracker": "Job Tracker",
                "interviewPrep": "Interview Prep",
                "outreach": "Outreach",
                "linkedin": "LinkedIn",
                "settings": "Settings",
                "billing": "Billing",
                "signOut": "Sign Out",
                "currentPlanLabel": "YOUR CURRENT PLAN IS",
                "wantMore": "WANT MORE?",
                "updateNow": "UPDATE NOW!",
                "planAriaLabel": "Current plan: {{plan}}. Go to billing",
                "lockedAriaLabel": "{{feature}} requires {{tier}}. Go to billing to upgrade"
            },
            "header": {
                "greeting": "Hi, {{name}}!",
                "subtitle": "Let's get you hired.",
                "toggleNavAriaLabel": "Toggle navigation menu",
                "profileMenuAriaLabel": "{{name}} profile menu",
                "adminPanel": "Admin Panel",
                "myProfile": "My Profile",
                "logout": "Log out"
            },
            "newCvModal": {
                "ariaLabel": "Upload a new CV",
                "title": "New CV",
                "subtitle": "Upload a PDF or DOCX — AI will analyze and ATS-score it.",
                "closeAriaLabel": "Close",
                "dropzoneAriaLabel": "Drop zone: drag a PDF or DOCX file here",
                "dropzoneText": "Drag your CV here",
                "browseFiles": "Browse files",
                "formatsHint": "PDF or DOCX · max 10 MB",
                "removeFile": "Remove file",
                "uploading": "Uploading…",
                "analyzing": "Analyzing your CV…",
                "analyzeCta": "Analyze my CV",
                "errors": {
                    "invalidType": "Only PDF and DOCX files are supported.",
                    "tooLarge": "File exceeds the 10 MB limit ({{size}}).",
                    "unsupportedType": "File type not accepted by the server.",
                    "tooLargeServer": "File is too large for the server.",
                    "sessionExpired": "Session expired. Please log in again.",
                    "uploadFailed": "Upload failed. Please try again.",
                    "analysisQuotaExhausted": "You've used all CV analyses for this period. Upgrade or wait for the next period.",
                    "analysisFailed": "Analysis failed. Please try another file.",
                    "pollFailed": "Could not check analysis status. Please refresh."
                }
            },
            "heroCard": {
                "ariaLabel": "Most recent CV result",
                "label": "YOUR MOST RECENT RESULT",
                "heading": "Your optimized CV is ready",
                "headingClean": "Looking great — no critical errors",
                "subtitle": "We found critical errors blocking your interviews.",
                "subtitleErrorSingular": "We found {{count}} critical error blocking your interviews.",
                "subtitleErrorPlural": "We found {{count}} critical errors blocking your interviews.",
                "subtitleClean": "Congratulations! No critical errors are blocking your interviews.",
                "subtitlePreview": "Your analysis preview is ready. Open Full analysis for the complete picture.",
                "viewCv": "View my CV",
                "fullAnalysis": "Full analysis"
            },
            "footer": {
                "product": "Product",
                "productFeatures": "Features",
                "productPricing": "Pricing",
                "productHowItWorks": "How it works",
                "company": "Company",
                "companyAbout": "About",
                "companyBlog": "Blog",
                "companyCareers": "Careers",
                "support": "Support",
                "supportHelpCenter": "Help Center",
                "supportContact": "Contact",
                "supportPrivacy": "Privacy",
                "copyright": "© 2026 HireFit. All rights reserved."
            }
        },
        "cvDetail": {
            "ariaLabel": "My CVs",
            "title": "My CV's",
            "subtitle": "Your score, optimized versions, and role fit.",
            "loadingAriaLabel": "Loading CV details",
            "emptyTitle": "Upload your first CV",
            "emptyHint": "Add a PDF or DOCX to see your ATS score and role matches.",
            "processingHint": "We're analyzing your CV. This usually takes a minute.",
            "failedHint": "We couldn't analyze your CV. Please try uploading it again.",
            "uploadLimitReached": "You've reached the CV upload limit for your plan.",
            "uploadAnalysis": {
                "title": "Your CV",
                "file": "File",
                "role": "Detected role"
            },
            "yourScore": "Your score",
            "scoreAriaLabel": "Your CV score",
            "scoreBlurb": "Great job! Your CV is well optimized and aligned with the best practices",
            "optimizedScoreLabel": "Optimized",
            "originalScoreLabel": "Original",
            "optimizedScoreAriaLabel": "Optimized CV score",
            "originalScoreAriaLabel": "Original first-analysis score",
            "dropzone": {
                "ariaLabel": "Drop zone: drag a PDF or DOCX file here",
                "title": "Drop your CV here",
                "hint": "Upload your CV (PDF or DOCX) to start the analysis",
                "cta": "Choose File",
                "formats": "PDF or DOCX — Max 10MB",
                "uploading": "Uploading your CV…",
                "analyzing": "Analyzing your CV…",
                "replaceAriaLabel": "Drop zone: drag a PDF or DOCX to replace your current CV",
                "replaceTitle": "Replace your CV",
                "replaceHint": "You can upload again, but doing so will overwrite your current analysis.",
                "replaceCta": "Replace File"
            },
            "matchedRequirements": "Matched Requirements",
            "missingRequirements": "Missing Requirements",
            "noMatchedRequirements": "No matched requirements listed.",
            "noMissingRequirements": "No missing requirements listed.",
            "downloadWithObservations": "Download CV with observations",
            "jdForm": {
                "title": "Job Description",
                "hint": "Tell us about the position you're applying for. We'll compare the job requirements with your CV and identify the keywords, skills, and experience you should highlight.",
                "step1Title": "1. Tailor Your CV to a Job",
                "step1Hint": "What position are you applying for?",
                "step1Example": "e.g. Customer Success Specialist",
                "step2Title": "2. Tailor Your CV to a Job",
                "step2Hint": "Paste the job description here. Include the responsibilities, requirements, and qualifications whenever possible.",
                "titleLabel": "Role title",
                "titlePlaceholder": "Enter Job Title",
                "rawLabel": "Job description text",
                "rawPlaceholder": "Paste your job description here…",
                "submit": "Analyse my job match",
                "success": "Job description added. Decoding may take a moment.",
                "decoded": "Job description ready — you can run a complete analysis now.",
                "selectForRewrite": "Use for complete analysis",
                "selectPlaceholder": "Select a parsed job description",
                "runRewrite": "Run complete analysis",
                "rewriteLocked": "Upgrade to Core or higher to run a complete analysis.",
                "jdCreateLocked": "Upgrade to Core, Pro, or Premium to create job descriptions.",
                "jdPerCvLimit": "Your plan includes 1 job description per CV.",
                "analysisTitle": "Job description analysis",
                "decoding": "Decoding this job description…",
                "seniority": "Seniority",
                "location": "Location",
                "employment": "Employment",
                "requiredSkills": "Required skills",
                "responsibilities": "Responsibilities",
                "optimizeQuotaExhausted": "You've used all complete analyses for this period. Upgrade or wait for the next period.",
                "rewritePending": "Complete analysis is still running. You can leave this page — it will keep going.",
                "rewriteCompleted": "Complete analysis finished. You can download it from My Analysis.",
                "rewriteStartedTitle": "Complete analysis started",
                "rewriteStartedBody": "This may take a few minutes. It's OK to leave this page — we'll keep working.",
                "rewriteStartedDismiss": "Got it",
                "status": {
                    "pending": "Pending",
                    "processing": "Decoding…",
                    "parsed": "Ready",
                    "failed": "Failed"
                },
                "errors": {
                    "createFailed": "Could not create the job description. Please try again.",
                    "decodeFailed": "Could not decode the job description. Please try again.",
                    "rewriteFailed": "Could not complete the analysis. Please try again.",
                    "timeout": "Complete analysis is taking longer than expected. Refresh My CVs in a few minutes to check if it finished."
                },
                "voiceNotesRequired": "Generate and answer the voice notes for this CV before running a complete analysis. Your answers feed the optimized CV.",
                "voiceNotesIncomplete": "Answer every voice note for this CV before running a complete analysis. Your answers feed the optimized CV.",
                "voiceNotesGateLink": "Go to Voice notes"
            },
            "resumeStatus": {
                "pending": "Pending",
                "processing": "Processing…",
                "analyzed": "Analyzed",
                "failed": "Failed"
            },
            "matchStatus": {
                "pending": "Pending",
                "processing": "Matching…",
                "completed": "Matched",
                "failed": "Failed"
            },
            "errors": {
                "loadFailed": "Could not load your CV details. Please refresh.",
                "downloadFailed": "Download failed. Please try again."
            },
            "voiceNotes": {
                "title": "Voice notes",
                "hint": "Generate follow-up questions from your CV analysis and job description, then answer them by voice.",
                "generateCta": "Generate voice questions",
                "generated": "{{count}} voice question(s) ready for this CV.",
                "upsell": "Voice notes start on Core (up to {{core}} questions). Pro includes up to {{pro}} guided notes. Premium includes up to {{premium}} questions.",
                "jdRequired": "Add a job description for this CV before generating voice notes.",
                "upgradeCta": "Upgrade to unlock voice notes",
                "limitHint": "Your plan allows up to {{limit}} voice question(s) per CV.",
                "errors": {
                    "generateFailed": "Could not generate voice questions. Try again.",
                    "tierRequired": "Voice notes require Core or higher. Upgrade to continue."
                }
            }
        },
        "jdSection": {
            "ariaLabel": "Job Description",
            "title": "Job Descriptions",
            "createLocked": "Upgrade to Core, Pro, or Premium to create job descriptions.",
            "jdPerCvLimit": "Your plan includes 1 job description per CV.",
            "selectCvRequired": "Select a CV before adding a job description.",
            "cvFieldLabel": "CV",
            "selectCvOption": "Select a CV",
            "subtitle": "Paste or upload a role for a specific CV — AI will decode requirements for matching.",
            "newJdLabel": "NEW JOB DESCRIPTION",
            "inputMethodAriaLabel": "Input method",
            "tabPasteText": "Paste text",
            "tabUploadFile": "Upload file",
            "titleFieldLabel": "Title",
            "titlePlaceholder": "e.g. Senior Backend Engineer",
            "companyFieldLabel": "Company",
            "companyPlaceholder": "Optional",
            "jdFieldLabel": "Job description",
            "jdTextareaPlaceholder": "Paste the full job posting here…",
            "dropzoneAriaLabel": "Drop zone: drag a PDF or DOCX file here",
            "dropzoneText": "Drag your job description here",
            "browseFiles": "Browse files",
            "formatsHint": "PDF or DOCX · max 10 MB",
            "removeFile": "Remove file",
            "saving": "Saving…",
            "decodeCta": "Decode job description",
            "yourRolesLabel": "YOUR ROLES",
            "loadingListAriaLabel": "Loading job descriptions",
            "emptyTitle": "No job descriptions yet.",
            "emptyHint": "Add your first role to unlock job-aware CV analysis.",
            "statusAriaLabel": "Status: {{status}}",
            "status": {
                "pending": "Pending",
                "processing": "Decoding…",
                "parsed": "Parsed",
                "failed": "Failed"
            },
            "errors": {
                "resumeRequired": "Select a CV before submitting a job description.",
                "titleRequired": "Title is required.",
                "textRequired": "Paste the job description text before submitting.",
                "fileRequired": "Select a PDF or DOCX file before submitting.",
                "invalidType": "Only PDF and DOCX files are supported.",
                "tooLarge": "File exceeds the 10 MB limit ({{size}}).",
                "loadFailed": "Could not load your job descriptions. Please refresh.",
                "badRequest": "Check title and content, then try again.",
                "unsupportedType": "File type not accepted by the server.",
                "tooLargeServer": "File is too large for the server.",
                "sessionExpired": "Session expired. Please log in again.",
                "saveFailed": "Could not save the job description. Please try again."
            }
        },
        "cvRewrite": {
            "ariaLabel": "Complete analysis",
            "title": "Complete analysis",
            "subtitle": "Pair an analyzed CV with a parsed role and your voice-note answers to generate a complete analysis.",
            "newRewriteLabel": "NEW COMPLETE ANALYSIS",
            "loadingOptionsAriaLabel": "Loading options",
            "cvFieldLabel": "CV",
            "noCvsOption": "No analyzed CVs yet",
            "selectCvOption": "Select a CV…",
            "jdFieldLabel": "Job description",
            "noJdsOption": "No parsed roles yet",
            "selectJdOption": "Select a role…",
            "noCvsHint": "Upload and analyze a CV first (status Analyzed).",
            "noJdsHint": "Add a job description and wait until status Parsed.",
            "upsell": "Available from the Core plan",
            "quotaExhausted": "You've used all complete analyses for this period. Upgrade or wait for the next period.",
            "starting": "Starting…",
            "submitCta": "Run complete analysis for this role",
            "artifactsLabel": "COMPLETE ANALYSES",
            "selectCvHint": "Select a CV to see its complete analyses.",
            "loadingArtifactsAriaLabel": "Loading artifacts",
            "noArtifactsTitle": "No complete analyses for this CV yet.",
            "noArtifactsHint": "Pick a parsed role and start your first complete analysis.",
            "itemName": "Complete analysis #{{id}}",
            "jdFallback": "JD #{{id}}",
            "statusAriaLabel": "Status: {{status}}",
            "downloadError": "Could not download the PDF. Please try again.",
            "downloading": "Downloading…",
            "downloadPdf": "Download PDF",
            "detailLabel": "COMPLETE ANALYSIS",
            "hide": "Hide",
            "hideAriaLabel": "Hide complete analysis detail",
            "noSelectionTitle": "No complete analysis selected.",
            "loadingDetailAriaLabel": "Loading complete analysis",
            "statusCompletedAriaLabel": "Status: Completed",
            "payloadPending": "Complete analysis finished but the result is not available yet.",
            "unavailable": "Complete analysis unavailable",
            "status": {
                "pending": "Pending",
                "processing": "Running complete analysis…",
                "completed": "Completed",
                "failed": "Failed"
            },
            "detailHints": {
                "pending": "Complete analysis is queued. Details will be available when status is Completed.",
                "processing": "Complete analysis is running. Check back in a moment…",
                "failed": "This complete analysis failed. Start a new one or pick another.",
                "none": "Select a complete analysis from the list to view details."
            },
            "section": {
                "summary": "Summary",
                "atsScore": "ATS score",
                "matchScore": "Match score",
                "matchedRequirements": "Matched requirements",
                "missingRequirements": "Missing requirements",
                "missingKeywords": "Missing keywords",
                "overusedKeywords": "Overused keywords",
                "keywordSuggestions": "Keyword suggestions",
                "rewrittenSections": "Rewritten sections",
                "intentLabel": "Intent:",
                "defendedEvidence": "Defended evidence"
            },
            "errors": {
                "loadOptionsFailed": "Could not load CVs and job descriptions. Please refresh.",
                "jdNotParsed": "Job description must be Parsed before a complete analysis. Check your selections.",
                "notFound": "Resume or job description not found.",
                "sessionExpired": "Session expired. Please log in again.",
                "artifactFailed": "The complete analysis could not be finished. Please try again.",
                "startFailed": "Could not start complete analysis. Please try again.",
                "detailLoadFailed": "Could not load complete analysis details. Please try again.",
                "timeout": "Complete analysis is taking longer than expected. Refresh this page in a few minutes to check if it finished."
            },
            "startedTitle": "Complete analysis started",
            "startedBody": "This may take a few minutes. It's OK to leave this page — we'll keep working.",
            "startedDismiss": "Got it"
        },
        "realityCheck": {
            "ariaLabel": "Reality Check Report",
            "title": "Reality Check Report",
            "subtitle": "Honest fit assessment, 30–45 day action plans, and ATS-safe CV sections.",
            "readyLabel": "READY TO GENERATE",
            "loadingArtifactsAriaLabel": "Loading artifacts",
            "noArtifactsTitle": "No completed analyses yet.",
            "noArtifactsHint": "Finish a complete analysis before generating a Reality Check.",
            "artifactTitle": "Complete analysis #{{id}}",
            "resumeLabel": "Resume {{id}}",
            "jdLabel": "JD {{id}}",
            "starting": "Starting…",
            "generating": "Generating…",
            "upsell": "Available from the Core plan",
            "generateCta": "Generate report",
            "viewCta": "View report",
            "regenerateCta": "Regenerate",
            "errors": {
                "loadDataFailed": "Could not load reality check data. Please refresh.",
                "loadResumesFailed": "Could not load your CVs. Please refresh.",
                "artifactNotReady": "Complete analysis is not ready. Finish it first.",
                "sessionExpired": "Session expired. Please log in again.",
                "generateFailed": "Could not generate the report. Please try again."
            },
            "detail": {
                "ariaLabel": "Reality Check Report detail",
                "yourReportLabel": "YOUR REPORT",
                "hide": "Hide",
                "loadingReportAriaLabel": "Loading report",
                "reportId": "Report #{{id}}",
                "statusAriaLabel": "Status: {{status}}",
                "atsScore": "ATS score",
                "matchScore": "Match score",
                "pollingHint": "AI is building your reality check. This usually takes under a minute…",
                "genericFailure": "Report generation failed. Try again.",
                "filteredBanner": "You're viewing the reduced view (Core plan): diagnosis and quick wins only. Upgrade to Pro for the full hypothesis analysis and complete roadmap.",
                "section": {
                    "realDiagnosis": "Real diagnosis",
                    "supportingEvidence": "Supporting evidence",
                    "strengthsToAcknowledge": "Strengths to acknowledge",
                    "roadmap": "Roadmap",
                    "pathA": "Path A — Quick wins",
                    "pathB": "Path B — Close the gap",
                    "pathC": "Path C — Strategic pivot",
                    "expectedOutcome": "Expected outcome:",
                    "yourHypotheses": "Your hypotheses, checked",
                    "evidenceLabel": "Evidence:",
                    "implicationsForSearch": "Implications for your search",
                    "interventionNeeded": "Intervention needed:",
                    "realisticTimeline": "Realistic timeline:",
                    "realisticRoles": "Realistic roles to apply to",
                    "rolesToAvoid": "Roles to avoid (and why)"
                },
                "status": {
                    "pending": "Pending",
                    "processing": "Generating…",
                    "completed": "Ready",
                    "failed": "Failed"
                },
                "validity": {
                    "valid": "Valid",
                    "partiallyValid": "Partially valid",
                    "excuse": "Excuse",
                    "notAddressed": "Not addressed"
                },
                "intervention": {
                    "repositioning": "Repositioning",
                    "reconstruction": "Reconstruction",
                    "pivot": "Pivot",
                    "minorPolish": "Minor polish"
                },
                "errors": {
                    "invalidId": "Invalid report id.",
                    "loadFailed": "Could not load the report. Please try again."
                }
            }
        },
        "jobMatches": {
            "ariaLabel": "Job Matches",
            "title": "Job Matches",
            "subtitle": "How your resume scores against each job description you've run a complete analysis for.",
            "loadingAriaLabel": "Loading job matches",
            "emptyTitle": "No job matches yet.",
            "emptyHint": "Run a complete analysis against a job description to see your match score here.",
            "statusAriaLabel": "Status: {{status}}",
            "status": {
                "pending": "Pending",
                "processing": "Matching…",
                "completed": "Matched",
                "failed": "Failed"
            },
            "errors": {
                "loadMatchesFailed": "Could not load job matches. Please refresh.",
                "loadResumesFailed": "Could not load your CVs. Please refresh."
            }
        },
        "statsRow": {
            "ariaLabel": "CV statistics"
        },
        "resultsOverview": {
            "ariaLabel": "Latest CV results",
            "detailedHeading": "Detailed scores",
            "errorsHeading": "Errors Detected",
            "fixedBadge": "Fixed in CV",
            "seeAllErrors": "See all errors",
            "noErrors": "No errors detected for this CV.",
            "upsell": "Unlock the full error breakdown with Core",
            "scoresExplainer": "How are these scores calculated?",
            "downloadCta": "Download Optimized CV",
            "downloadHint": "Available once you run a complete analysis from My CVs.",
            "downloadFailed": "Could not download your CV. Please try again."
        },
        "matchBoard": {
            "ariaLabel": "Plan, job matches, and applications",
            "heading": "We help you find your perfect match",
            "jobsHeading": "Jobs You Match With",
            "seeMoreMatches": "See more roles on Job Tracker →",
            "basedOnCv": "Based on your CV",
            "careerPathBadge": "Career path",
            "jobsLoading": "Loading suggested roles…",
            "jobsLoadFailed": "Couldn't load suggested roles. Try again later.",
            "jobsEmptyTitle": "Run a complete analysis to unlock role matches",
            "jobsEmptyBody": "Run a complete analysis on My CVs first. We use that result to suggest other jobs you can match and apply to.",
            "jobsEmptyCta": "Go to My CVs →",
            "freeChecklistAria": "Features by plan",
            "availableOn": "Available on {{plan}}",
            "freeChecklistCta": "View plans & upgrade →"
        },
        "scoreRing": {
            "ariaLabel": "Overall score {{score}} out of 100",
            "outOf": "/100"
        },
        "myAnalysis": {
            "ariaLabel": "My Analysis",
            "loadingAriaLabel": "Loading analysis",
            "yourScore": "Your score",
            "downloadOptimizedCv": "Download Optimized CV",
            "optimizedCvHint": "Available after a complete analysis from My CVs.",
            "errorsHeading": "Errors Detected",
            "fixInCv": "Fix it in CV",
            "upgradeToPro": "Upgrade to PRO",
            "seePlans": "See plans →",
            "fixedBadge": "Fixed in CV",
            "noErrors": "No errors detected for this CV.",
            "upsell": "Unlock the full error breakdown with Core",
            "detailedHeading": "Detailed scores",
            "compareHeading": "Comparative Before and After",
            "afterLabel": "After",
            "beforeLabel": "Before",
            "improvedPoints": "Improved points",
            "skillsGapHeading": "SKILLS GAP ANALYSIS",
            "skillsGapFallback": "Run a full analysis to see how your skills compare to the roles you're targeting.",
            "downloadAnalysis": "Download Analysis",
            "optimizedScoreLabel": "Optimized",
            "optimizedScoreAriaLabel": "Optimized CV score",
            "rewritePreview": {
                "title": "Analysis snapshot",
                "hint": "A short view of your latest complete analysis. Both downloads stay off until you run a complete analysis on My CVs. Download Analysis exports the full result. Download Optimized CV exports the Harvard-format CV.",
                "analysisHeading": "Latest analysis",
                "rewriteHeading": "Latest complete analysis",
                "scoreLabel": "Score",
                "atsLabel": "ATS",
                "matchLabel": "Match",
                "empty": "No completed analysis yet. Run a complete analysis on My CVs.",
                "ctaHint": "Available after a complete analysis from My CVs.",
                "errors": {
                    "missingInputs": "Upload a CV and add a job description first.",
                    "rewriteFailed": "Could not complete the analysis. Please try again.",
                    "timeout": "The complete analysis is taking longer than expected. Check My CVs in a moment.",
                    "downloadFailed": "Download failed. Please try again.",
                    "optimizedCvMissing": "This complete analysis was saved before optimized CVs. Run a new complete analysis to generate the Harvard CV."
                }
            },
            "otherRolesTitle": "Other roles you could fit into",
            "otherRolesEmptyTitle": "No career paths to show right now.",
            "otherRolesEmptyHint": "Run a complete analysis on My CVs to generate suggested career paths for your profile.",
            "otherRolesEmptyCta": "Go to My CVs →",
            "otherRolesLoading": "Loading suggested roles…",
            "otherRolesLoadFailed": "Couldn't load suggested roles. Try again later.",
            "careerPathBadge": "Career path",
            "matchBasedOnCv": "BASED ON YOUR CV",
            "roleFitTitle": "Role fit",
            "emptyState": {
                "title": "No analysis yet",
                "body": "Scores stay at 0 until you upload a CV. Upload one on My CVs to unlock your analysis.",
                "cta": "Upload a CV →"
            }
        },
        "scoreSection": {
            "ariaLabel": "CV score preview",
            "frontAlt": "Optimized CV document",
            "hint": "ⓘ How are these scores calculated?"
        },
        "detailedScores": {
            "heading": "Detailed scores",
            "notAvailable": "N/A"
        },
        "errorsDetected": {
            "heading": "Errors Detected",
            "fixedBadge": "Fixed in CV",
            "seeAllLink": "See all errors →"
        },
        "sevenDayPlan": {
            "ariaLabel": "7 Day Plan",
            "heading": "7-Day Plan",
            "onDay": "You are on your day {{day}}!",
            "progressMeta": "{{progress}} % completed - {{days}} days remaining",
            "progressText": "{{progress}}% completed · 4 days remaining",
            "stepAriaLabel": "Step {{step}}",
            "completedAriaLabel": "Completed",
            "seeFullPlanLink": "See full plan →",
            "lockedBody": "The 7-day plan is available on {{plan}} and above.",
            "lockedCta": "View plans & upgrade →",
            "completedHeading": "Completed",
            "nextStepsHeading": "Next steps",
            "dayLabel": "Day",
            "todayBadge": "TODAY",
            "todayAriaLabel": "Day {{day}} details",
            "sectionATitle": "Jobs that match your CV",
            "sectionADesc": "Openings found on the web for the CV optimized in your latest complete analysis.",
            "sectionBTitle": "Use your optimized CV",
            "sectionBDesc": "Download your latest complete analysis or review it before you apply.",
            "sectionCTitle": "Update your Application Tracker",
            "sectionCDesc": "Log each application so you can follow up on time.",
            "linkedin": "LinkedIn",
            "otherPlatform": "Other platform",
            "linkedinOffer": "LinkedIn offer",
            "otherOffer": "Other offer",
            "matchLabel": "{{score}}% match",
            "apply": "Apply",
            "moreLinkedin": "Go to LinkedIn to find more >",
            "moreOther": "Go to Job Matches to find more >",
            "downloadCv": "Download Optimized CV",
            "reviewCv": "Review New CV",
            "or": "or",
            "goToTracker": "Go to Application Tracker >",
            "day2Companies": {
                "heading": "Top companies with jobs that match your CV",
                "description": "Ranked from Job Tracker openings found for your optimized CV. Saved once for this plan — refreshing does not recompute.",
                "loading": "Loading top companies…",
                "loadFailed": "Top companies could not be loaded.",
                "empty": "No matching jobs yet. Run a complete analysis from My CVs so Job Tracker can find openings, then revisit Day 2.",
                "jobCount": "{{count}} open roles",
                "goToJobTracker": "See jobs on Job Tracker >"
            },
            "whyHeading": "Why it matters",
            "whyP1": "A focused 7-day plan turns scattered job-search effort into daily progress — CV, outreach, and interviews working together.",
            "whyP2": "Completing each step compounds: better applications today mean stronger interviews and offers next week.",
            "days": {
                "d1": {
                    "title": "Optimize CV + Update LinkedIn",
                    "todayHint": "Today - Optimize your CV",
                    "sectionATitle": "Apply to 5-10 roles that match with your CV",
                    "sectionADesc": "Open roles on LinkedIn and other platforms using your optimized CV. (Temporary placeholder - replace with final day copy.)",
                    "sectionBTitle": "Use your optimized CV",
                    "sectionBDesc": "Download the CV analyzed by HireFit, or review it before you apply. (Temporary placeholder.)",
                    "sectionCTitle": "Update your Application Tracker",
                    "sectionCDesc": "Log each application so you can follow up on time. (Temporary placeholder.)",
                    "tableTaskHeading": "Task",
                    "tableMinHeading": "Minimum (45-60 min)",
                    "tableIdealHeading": "Ideal (2-3 h)",
                    "d1DownloadCv": "Download your CV",
                    "d1DownloadCvMin": "Download your CV optimized in {idioma_vacantes}",
                    "d1DownloadCvIdeal": "Same + a version in the other language if you're applying to both markets",
                    "d1UpdateLinkedin": "Update LinkedIn",
                    "d1UpdateLinkedinMin": "Change your headline to: \"{headline_sugerido}\"",
                    "d1UpdateLinkedinIdeal": "Headline + About section + your last 2 experiences matching your CV",
                    "d1OpenToWork": "Open to Work",
                    "d1OpenToWorkMin": "{instruccion_open_to_work}",
                    "d1OpenToWorkIdeal": "Same + add the 3 exact job titles you're looking for",
                    "d1BlockTime": "Block your time",
                    "d1BlockTimeMin": "Schedule this week's job-search blocks in your calendar",
                    "d1BlockTimeIdeal": "Same"
                },
                "d2": {
                    "title": "Define objective + save 10 jobs",
                    "todayHint": "Today - Top companies that match your CV",
                    "sectionATitle": "Apply to 5-10 roles that match with your CV",
                    "sectionADesc": "Open roles on LinkedIn and other platforms using your optimized CV. (Temporary placeholder - replace with final day copy.)",
                    "sectionBTitle": "Use your optimized CV",
                    "sectionBDesc": "Download the CV analyzed by HireFit, or review it before you apply. (Temporary placeholder.)",
                    "sectionCTitle": "Update your Application Tracker",
                    "sectionCDesc": "Log each application so you can follow up on time. (Temporary placeholder.)"
                },
                "d3": {
                    "title": "Adapt your CV, apply, and message recruiters",
                    "todayHint": "Today — Adapt, apply, and message",
                    "sectionATitle": "Adapt your CV",
                    "sectionADesc": "For each vacancy you apply to: adjust your summary and 2–3 bullets with the wording from the job description — invent nothing",
                    "sectionBTitle": "Apply",
                    "sectionBDesc": "4 applications",
                    "sectionCTitle": "Message the recruiter",
                    "sectionCDesc": "If you find the recruiter, send the T1 message the same day",
                    "tableTaskHeading": "Task",
                    "tableMinHeading": "Minimum (45-60 min)",
                    "adaptCv": "Adapt your CV",
                    "adaptCvMin": "For each vacancy you apply to: adjust your summary and 2–3 bullets with the wording from the job description — invent nothing",
                    "apply": "Apply",
                    "applyMin": "4 applications",
                    "messageRecruiter": "Message the recruiter",
                    "messageRecruiterMin": "If you find the recruiter, send the T1 message the same day"
                },
                "d4": {
                    "title": "Connect with 10 recruiters on LinkedIn",
                    "todayHint": "Today - Connect with recruiters",
                    "sectionATitle": "Close network",
                    "sectionADesc": "Send T2 to 5 people who already know you (former colleagues, friends in the field)",
                    "sectionBTitle": "Recruiters",
                    "sectionBDesc": "Send T3 to 3 recruiters at your target companies",
                    "sectionCTitle": "Referrals",
                    "sectionCDesc": "Ask for 1 referral (T4) for your best vacancy",
                    "tableTaskHeading": "Task",
                    "tableMinHeading": "Minimum (45-60 min)",
                    "tableIdealHeading": "Ideal (2-3 h)",
                    "closeNetwork": "Close network",
                    "closeNetworkMin": "Send T2 to 5 people who already know you (former colleagues, friends in the field)",
                    "closeNetworkIdeal": "Send T2 to 20 people",
                    "recruiters": "Recruiters",
                    "recruitersMin": "Send T3 to 3 recruiters at your target companies",
                    "recruitersIdeal": "Send T3 to 10",
                    "referrals": "Referrals",
                    "referralsMin": "Ask for 1 referral (T4) for your best vacancy",
                    "referralsIdeal": "Ask for 3"
                },
                "d5": {
                    "title": "Interview preparation (STAR method)",
                    "todayHint": "Today - Prepare for interviews",
                    "tableTaskHeading": "Task",
                    "tableMinHeading": "Minimum (45-60 min)",
                    "tableIdealHeading": "Ideal (2-3 h)",
                    "pitch": "Your pitch",
                    "pitchMin": "Write and record your 60-second \"Tell me about yourself\". Base: \"{pitch_base}\"",
                    "pitchIdeal": "Same + record it 3 times and keep the best one",
                    "starStories": "STAR stories",
                    "starStoriesMin": "Prepare 2 stories with your achievements: {logros_para_star}",
                    "starStoriesIdeal": "Prepare 4",
                    "probableQuestions": "Likely questions",
                    "probableQuestionsMin": "Practice out loud: {3_preguntas_probables}",
                    "probableQuestionsIdeal": "Same + HireFit Mock Interview (Premium)",
                    "gapTask": "{tarea_gap}",
                    "gapTaskMin": "{tarea_gap_minimo}",
                    "gapTaskIdeal": "{tarea_gap_ideal}"
                },
                "d6": {
                    "title": "Follow up on applications",
                    "todayHint": "Today - Follow up",
                    "tableTaskHeading": "Task",
                    "tableMinHeading": "Minimum (45-60 min)",
                    "d6FollowUps": "Follow-ups",
                    "d6FollowUpsMin": "Send T5 to applications with 5–7 business days and no reply. Max 2 per vacancy.",
                    "d6ThankYous": "Thank-yous",
                    "d6ThankYousMin": "Send T6 within 24 hours after each interview.",
                    "d6RespondNetwork": "Respond to your network",
                    "d6RespondNetworkMin": "Reply to anyone who responded and schedule calls.",
                    "d6LogEverything": "Log everything",
                    "d6LogEverythingMin": "Update each vacancy status: applied, replied, interview, rejected."
                },
                "d7": {
                    "title": "Review progress + plan next week",
                    "todayHint": "Today - Review your week",
                    "sectionATitle": "Apply to 5-10 roles that match with your CV",
                    "sectionADesc": "Open roles on LinkedIn and other platforms using your optimized CV. (Temporary placeholder - replace with final day copy.)",
                    "sectionBTitle": "Use your optimized CV",
                    "sectionBDesc": "Download the CV analyzed by HireFit, or review it before you apply. (Temporary placeholder.)",
                    "sectionCTitle": "Update your Application Tracker",
                    "sectionCDesc": "Log each application so you can follow up on time. (Temporary placeholder.)",
                    "metricsHeading": "Your week in numbers",
                    "tableMetricHeading": "Metric",
                    "tableLastEntryHeading": "Last entry number",
                    "tableNumberHeading": "Your number",
                    "metrics": {
                        "savedVacancies": "Saved vacancies",
                        "applicationsSent": "Applications sent",
                        "messagesSent": "Messages sent to people",
                        "positiveResponses": "Positive responses (to applications or messages)",
                        "hrScreenings": "HR calls / screenings",
                        "teamInterviews": "Interviews with the team",
                        "nextRound": "Advanced to the next round"
                    }
                }
            },
            "offers": {
                "o1Title": "Customer Service Trainer",
                "o1Meta": "Remote - Full time",
                "o2Title": "Learning & Development Specialist",
                "o2Meta": "Hybrid - Full time",
                "o3Title": "Client Success Manager",
                "o3Meta": "Remote - Full time",
                "o4Title": "Training Coordinator",
                "o4Meta": "On-site - Full time",
                "o5Title": "Instructional Designer",
                "o5Meta": "Remote - Contract",
                "o6Title": "People Experience Associate",
                "o6Meta": "Hybrid - Full time"
            },
            "loading": "Loading your 7-day plan...",
            "loadFailed": "Could not load the plan. Try again.",
            "noResume": "Upload a CV to generate your 7-day plan.",
            "goUploadCv": "Go to My CVs ->",
            "completeCta": "Complete",
            "completing": "Saving...",
            "completeFailed": "Could not complete this day. Try again.",
            "completedOn": "Completed on {{date}}",
            "nextStepLabel": "Next step",
            "upcomingLabel": "Upcoming",
            "noneCompletedYet": "No days completed yet.",
            "allDaysDone": "You finished all 7 days!",
            "allCompleteTitle": "You completed your 7-day plan!",
            "dayDetailHeading": "DAY {{day}} - TODAY - {{title}}",
            "tasksHeading": "Today's checklist",
            "tasksIncompleteHint": "Check off all required tasks to enable Complete.",
            "interviewPrepCta": "Go to Interview Prep",
            "jobTrackerCta": "Go to Job Tracker",
            "linkedinCta": "Go to LinkedIn",
            "premiumBadge": "PREMIUM",
            "repeatCta": "Repeat the process",
            "resetting": "Resetting...",
            "resetFailed": "Could not reset the plan. Try again.",
            "metricsIncompleteHint": "Enter a number (0 or more) for every metric to enable Complete.",
            "metricsSaveFailed": "Could not save that metric. Try again.",
            "taskToggleFailed": "Could not update that task. Try again."
        },
        "applicationTracker": {
            "heading": "Application Tracker",
            "lockedBody": "Application Tracker is available on {{plan}} and above. Upgrade to track applications, status, and next steps in one place.",
            "lockedCta": "View plans & upgrade →",
            "emptyBody": "Your plan includes Application Tracker. Start logging applications to keep follow-ups and interviews organized.",
            "emptyCta": "Open Job Tracker →",
            "loading": "Loading interview questions...",
            "loadFailed": "Couldn’t load applications right now. Try again from Job Tracker.",
            "tableAriaLabel": "Job applications",
            "actionColumnLabel": "Action",
            "columns": {
                "company": "Company",
                "role": "Role",
                "date": "Date",
                "status": "Status",
                "nextStep": "Next step"
            },
            "seeApplicationLink": "See application",
            "viewAllLink": "View all applications →"
        },
        "jobTracker": {
            "ariaLabel": "Job Tracker",
            "heading": "Application Tracker",
            "tableAriaLabel": "Job applications",
            "actionColumnLabel": "Action",
            "columns": {
                "company": "Company",
                "role": "Role",
                "date": "Date",
                "status": "Status",
                "nextStep": "Next step"
            },
            "status": {
                "APPLIED": "Applied",
                "IN_INTERVIEW": "In interview",
                "PENDING": "Pending",
                "REJECTED": "Rejected"
            },
            "nextSteps": {
                "FOLLOW_UP_ON_MY_END": "Follow up on my end",
                "WAITING_FOR_UPDATE": "Waiting for update",
                "PENDING_DATA_ON_MY_END": "Pending data on my end"
            },
            "addApplication": "Add new application",
            "saveEdits": "Save",
            "matchedJobs": {
                "title": "Jobs that match your CV",
                "description": "Openings found on the web for the CV optimized in your latest complete analysis, filtered by your location.",
                "loading": "Looking up matching jobs…",
                "loadFailed": "Matching jobs could not be loaded.",
                "empty": "Run a complete analysis from My CVs to see jobs that match your optimized CV.",
                "emptyAfterAnalysis": "No open roles were found for this CV. Find matching jobs stays unavailable until you run a new analysis on another CV.",
                "alreadySaved": "Matching jobs for this analysis are already saved. Find matching jobs stays unavailable until you run a new analysis on another CV.",
                "work": {
                    "REMOTE": "Remote",
                    "HYBRID": "Hybrid",
                    "OFFICE": "Office"
                },
                "time": {
                    "FULL_TIME": "Full time",
                    "PART_TIME": "Part time"
                },
                "locationLabel": "Your location",
                "locationPlaceholder": "City and country, e.g. San José, Costa Rica",
                "locationHelp": "Required. Matching jobs are filtered to this location (not worldwide).",
                "includeRemote": "Also include completely remote jobs",
                "search": "Find matching jobs",
                "searching": "Searching…",
                "needLocation": "Enter your location above to find jobs that match your optimized CV.",
                "searchFailed": "Could not search for matching jobs. Please try again.",
                "readyToSearch": "Location saved. Click “Find matching jobs” to search with your optimized CV."
            },
            "notifications": {
                "heading": "Notifications",
                "intro": "Choose how HireFit should remind you about follow-ups, interviews, and next steps in your job search.",
                "optInQuestion": "Would you like to receive notifications and reminders?",
                "optInYes": "Yes, keep me updated!",
                "optInNo": "No, I prefer not to receive reminders.",
                "channelQuestion": "How would you like to receive them?",
                "smsTitle": "Cellphone (SMS)",
                "smsDesc": "You will receive messages on your phone",
                "emailTitle": "Email",
                "emailDesc": "Receive your reminders through your inbox",
                "otherTitle": "Other platform",
                "otherDesc": "Get reminders on another messaging app",
                "otherPlaceholder": "Such as Whatsapp, Telegram, Slack, etc",
                "save": "Save preferences",
                "cancel": "Cancel"
            },
            "delete": "Delete",
            "rowMenuAriaLabel": "Application actions",
            "loading": "Loading applications…",
            "empty": "No applications yet. Add your first one.",
            "errors": {
                "loadFailed": "Could not load applications. Please try again.",
                "createFailed": "Could not create the application. Please try again.",
                "updateFailed": "Could not save changes. Please try again.",
                "deleteFailed": "Could not delete the application. Please try again."
            }
        },
        "outreach": {
            "ariaLabel": "Outreach messages",
            "title": "Outreach Messages",
            "subtitle": "Recruiter messages written from your optimized CV and the job description.",
            "exclusivePrefix": "Exclusive for",
            "planPro": "Pro",
            "exclusiveAnd": "and",
            "planPremium": "Premium",
            "exclusiveSuffix": "plans",
            "linkedinLabel": "LinkedIn message",
            "emailLabel": "Email",
            "readyBadge": "Ready to copy",
            "copyMessage": "Copy message",
            "copied": "Copied!",
            "copyLinkedinAria": "Copy LinkedIn message",
            "copyEmailAria": "Copy email message",
            "subjectPrefix": "Subject",
            "loading": "Writing your recruiter messages from the optimized CV...",
            "emptyNoCv": "Upload a CV before generating outreach messages.",
            "emptyNoRewrite": "Run complete analysis on your CV and job description to generate a LinkedIn message and an email.",
            "errors": {
                "loadFailed": "Could not write outreach messages. Please try again."
            }
        },
        "linkedin": {
            "ariaLabel": "LinkedIn optimization",
            "title": "LinkedIn + Brand Card",
            "subtitle": "Optimize your LinkedIn profile and get a professional Brand Card to stand out and create a strong first impression.",
            "mockupTitle": "Mockup - LinkedIn Optimization",
            "originalLabel": "Original:",
            "optimizedBadge": "Optimized",
            "copyMessage": "Copy message",
            "copied": "Copied!",
            "footnote": "All suggestions are generated automatically based on your optimized CV and target role.",
            "loading": "Building your LinkedIn copy from the optimized CV...",
            "emptyNoCv": "Upload a CV and run analysis before optimizing your LinkedIn profile.",
            "emptyNoRewrite": "Run complete analysis on your CV and job description to generate LinkedIn headline, about, and experience.",
            "experienceEmpty": "The optimized CV did not include any employers to rewrite.",
            "downloading": "Preparing...",
            "errors": {
                "loadFailed": "Could not build LinkedIn copy. Please try again.",
                "downloadFailed": "Could not prepare the banner download. Please try again."
            },
            "headline": {
                "label": "Headline",
                "original": "Customer Service Trainer | Team Lead",
                "optimized": "Customer Service Training Specialist | Boosting Team Performance +35% | Remote | LATAM",
                "copyAria": "Copy optimized headline"
            },
            "about": {
                "label": "About",
                "original": "I have experience in customer service and team training...",
                "optimizedP1": "Customer Service Training Specialist with 5+ years of experience leading high-performing support teams across LATAM.",
                "optimizedP2": "I design and deliver training programs that turn average teams into high-retention, high-performance units.",
                "optimizedLead": "Proven track record:",
                "bullet1": "+35% team retention",
                "bullet2": "−40% onboarding time",
                "bullet3": "Improved training efficiency across remote teams",
                "bullet4": "Available for remote opportunities in LATAM and US",
                "copyAria": "Copy optimized About section"
            },
            "experience": {
                "label": "Experience",
                "original": "Customer Service Trainer — conducted team training.",
                "optimizedP1": "Designed and delivered training programs for customer service teams, focusing on performance, retention, and faster onboarding.",
                "optimizedP2": "Created performance tracking systems that helped managers identify skill gaps early and reduced onboarding time by 40%.",
                "copyAria": "Copy optimized experience",
                "skillsLabel": "Skills"
            },
            "assets": {
                "ariaLabel": "LinkedIn banners and Brand Card",
                "title": "Mockup - LinkedIn Banner & Brand Card",
                "subtitle": "3 banner options generated automatically - name, target role, positioning phrase and your email",
                "banner1": "Banner Option 1",
                "banner2": "Banner Option 2",
                "banner3": "Banner Option 3",
                "download": "Download"
            }
        },
        "interviewPrep": {
            "ariaLabel": "Interview preparation",
            "hero": {
                "ariaLabel": "Mock interview preparation banner",
                "eyebrow": "Mock Interview",
                "headingLine1": "Interview",
                "headingLine2": "PREPARATION",
                "copy": "Practice typical interview questions in a mock interview.",
                "speakerAria": "Play mock interview prompt"
            },
            "sections": {
                "personal": "Personal",
                "strengths": "Strengths, Weaknesses, and Motivations",
                "situational": "Situational & Behavioral",
                "rrhh": "HR / Personal",
                "behavioral": "Behavioral",
                "technical": "Technical"
            },
            "answerLabel": "Your answer to question {{number}}",
            "answerPlaceholder": "Enter Your Answer",
            "startRecording": "Record answer for question {{number}}",
            "stopRecording": "Stop recording answer for question {{number}}",
            "footnote": "Your answers are private — practice as many times as you like.",
            "questions": {
                "q1": {
                    "question": "Can you tell me about yourself?",
                    "tip": "Connect your educational background or current career path directly to the job you want."
                },
                "q2": {
                    "question": "Why should we hire you?",
                    "tip": "Match your specific skills and past successes to the exact goals listed in the job description."
                },
                "q3": {
                    "question": "Why do you want to work here?",
                    "tip": "Research the company culture and mission to explain how your values match theirs."
                },
                "q4": {
                    "question": "What are your greatest strengths?",
                    "tip": "Pick a strength mentioned in the job description and back it up with a quick example."
                },
                "q5": {
                    "question": "What are your weaknesses?",
                    "tip": "Name a real area of growth and explain the concrete steps you take to improve it."
                },
                "q6": {
                    "question": "What motivates you?",
                    "tip": "Share a professional example of how solving a problem or helping a team drives your work."
                },
                "q7": {
                    "question": "Tell me about a time you faced a challenge.",
                    "tip": "Use the STAR method (Situation, Task, Action, Result) to tell a short story about how you solved a difficult work problem."
                },
                "q8": {
                    "question": "Why are you leaving your current job?",
                    "tip": "Keep your focus positive by framing the move as a step toward new growth and responsibility."
                }
            },
            "loading": "Loading interview questions...",
            "emptyNoCv": "Upload a CV first to get interview questions tailored to your job description.",
            "emptyNoQuestions": "No interview questions could be assigned yet. Add a job description to your CV and try again.",
            "errors": {
                "loadFailed": "Could not load interview prep questions. Please try again.",
                "saveFailed": "Could not save your answer. Please try again.",
                "emptyTypedAnswer": "Type an answer before saving.",
                "feedbackFailed": "Could not generate feedback. Please try again.",
                "resetFailed": "Could not reset your answers. Please try again."
            },
            "preferRecordingHint": "Tip: recording usually captures more detail than typing.",
            "typeAnswerLabel": "Or type your answer",
            "typeAnswerPlaceholder": "Type your answer here…",
            "saveTypedCta": "Save",
            "saving": "Saving…",
            "resetCta": "Reset answers",
            "resetting": "Resetting…",
            "feedback": {
                "ariaLabel": "Interview prep feedback versus job description",
                "title": "Feedback vs job description",
                "loading": "Comparing your answers to the job description…",
                "strengths": "Strengths",
                "improvements": "Points of improvement",
                "suggestions": "Suggestions"
            }
        },
        "settings": {
            "eyebrow": "Settings",
            "title": "My profile",
            "loading": "Loading your profile…",
            "loadError": "Could not load your profile. Please try again later.",
            "firstNameLabel": "First name",
            "lastNameLabel": "Last name",
            "emailLabel": "Email address",
            "passwordLabel": "New password",
            "passwordPlaceholder": "Leave blank to keep current password",
            "currentPasswordLabel": "Current password",
            "currentPasswordPlaceholder": "Enter your current password",
            "languageLabel": "Language",
            "languageEn": "English",
            "languageEs": "Spanish",
            "submitDefault": "Save changes",
            "submitLoading": "Saving…",
            "successMessage": "Profile updated successfully.",
            "privacy": {
                "eyebrow": "Privacy",
                "title": "Privacy & Data",
                "intro": "Download a copy of your HireFit data, or permanently delete your account.",
                "exportTitle": "Download my data",
                "exportDescription": "Export a JSON file with your profile and related HireFit data.",
                "exportButton": "Download my data",
                "exportLoading": "Preparing download…",
                "exportError": "Could not export your data. Please try again.",
                "dangerTitle": "Danger zone",
                "dangerDescription": "Deleting your account permanently removes your CVs, analyses, reports, and voice notes. There is no grace period and this cannot be undone.",
                "deleteButton": "Delete my account",
                "deleteModalTitle": "Delete your account?",
                "deleteModalBody": "This permanently deletes your account and all associated data — CVs, analyses, reports, and voice notes. There is no grace period and you cannot undo this action.",
                "deleteConfirm": "Delete account",
                "deleteLoading": "Deleting…",
                "deleteCancel": "Cancel",
                "deleteError": "Could not delete your account. Please try again.",
                "deletePasswordRequired": "Enter your current password to delete your account.",
                "closeAriaLabel": "Close"
            },
            "errors": {
                "firstNameRequired": "First name is required.",
                "firstNameMax": "First name must be at most 100 characters.",
                "lastNameRequired": "Last name is required.",
                "lastNameMax": "Last name must be at most 100 characters.",
                "emailRequired": "Email is required.",
                "emailInvalid": "Please enter a valid email address.",
                "passwordTooShort": "Password must be at least 8 characters.",
                "currentPasswordRequired": "Current password is required to set a new password.",
                "currentPasswordIncorrect": "Current password is incorrect.",
                "emailConflict": "That email is already in use.",
                "validation": "Please check your information and try again.",
                "forbidden": "You do not have permission to update this profile.",
                "notFound": "Profile not found.",
                "submitFallback": "Could not update your profile. Please try again."
            }
        },
        "billing": {
            "eyebrow": "Billing",
            "title": "Your plan",
            "loading": "Loading your plan…",
            "errorMessage": "Could not load your billing information. Please try again later.",
            "upgradeCta": "Upgrade",
            "currentPlanLabel": "Current plan",
            "expiresLabel": "License expires",
            "expiresOn": "Expires on {{date}}",
            "expiredOn": "Expired on {{date}}",
            "noExpiry": "No expiration date on file",
            "tierHeading": {
                "free": "Your current plan",
                "upgraded": "Congratulations!",
                "default": "Billing"
            },
            "tierMessage": {
                "free": "You are on the {{plan}} plan. Upgrade to unlock more CV analysis, career insights, and premium features.",
                "core": "You have the {{plan}} plan. Want to improve your plan even more and unlock additional HireFit capabilities?",
                "pro": "You have the {{plan}} plan. Want to improve your plan even more and get the fullest HireFit experience?",
                "premium": "You have the {{plan}} plan — the best plan available on HireFit. Enjoy full access to everything we offer."
            }
        },
        "tierPlaceholder": {
            "billingCta": "View plans & upgrade",
            "fallbackTitle": "Feature",
            "fallbackBody": "This HireFit feature is available on a higher plan.",
            "linkedinBody": "LinkedIn optimization and recruiter-facing profile checks are available on Premium only. Full automation continues to roll out here.",
            "interviewPrepBody": "Mock interview voice notes and interview prep are available on Pro.",
            "outreachBody": "Cold outreach messages and positioning paths are available on Pro."
        },
        "voiceNotes": {
            "heading": "Voice notes",
            "subtitle": "Answer assigned questions for your CV. Record up to {{seconds}} seconds per answer.",
            "noPending": "No pending voice questions for this CV. Generate questions above when available.",
            "pickQuestion": "Choose a question to answer",
            "answering": "Answering:",
            "starting": "Starting...",
            "saving": "Saving...",
            "startCta": "Start recording",
            "stopCta": "Stop recording",
            "recordingLabel": "Recording",
            "remainingLabel": "{{seconds}}s remaining",
            "remainingAriaLabel": "{{seconds}} seconds remaining",
            "errors": {
                "invalidSampleRate": "Sample rate must be a positive number.",
                "startFailed": "Failed to start streaming session.",
                "noSpeechDetected": "No speech detected. Try recording again.",
                "saveFailed": "Failed to save voice note.",
                "noQuestionSelected": "Select a pending question before recording.",
                "websocketUrlFailed": "Could not build websocket URL.",
                "websocketError": "WebSocket connection error.",
                "microphoneUnavailable": "Microphone API is not available in this browser.",
                "emptyTypedAnswer": "Type an answer before saving.",
                "answerLocked": "These notes are locked after you answered them all."
            },
            "preferRecordingHint": "Tip: recording usually captures more detail than typing.",
            "typeAnswerLabel": "Or type your answer",
            "typeAnswerPlaceholder": "Type your answer here…",
            "saveTypedCta": "Save"
        },
        "voiceHistory": {
            "ariaLabel": "Saved voice notes",
            "heading": "Saved voice notes",
            "subtitle": "Assigned questions and your transcribed answers for each CV.",
            "loading": "Loading voice notes...",
            "emptyHint": "No voice notes yet. Generate questions on My CVs.",
            "awaitingAnswer": "Waiting for your answer…",
            "rerecord": "Re-record",
            "rerecordFailed": "Could not reopen this voice note. Please try again.",
            "loadFailed": "Could not load saved voice notes.",
            "status": {
                "pendingAnswer": "Pending answer",
                "received": "Saved",
                "processing": "Processing",
                "processed": "Processed",
                "failed": "Failed"
            }
        },
        "service": {
            "stats": {
                "cvsOptimized": "Complete analyses",
                "lastScore": "Last Score",
                "rolesAnalyzed": "Roles analyzed",
                "sevenDayPlan": "7-Day Plan"
            },
            "statsLinks": {
                "seeDetailedScore": "See detailed score →",
                "seeRolesYouFit": "See roles you fit →",
                "seeWhatsPending": "See what's pending →"
            },
            "scoreNames": {
                "atsCompatibility": "ATS Compatibility",
                "impactScore": "Impact Score",
                "clarity": "Clarity",
                "roleFit": "Role Fit"
            },
            "errors": {
                "mockNoMetricsTitle": "No quantifiable metrics",
                "mockNoMetricsDesc": "4 of your 6 bullet points have no measurable results.",
                "mockMissingJdTitle": "Missing JD Keywords",
                "mockMissingJdDesc": "Missing 8 key terms that are critical to pass ATS",
                "missingKeywordsTitle": "Missing Keywords",
                "missingKeywordsDesc": "Missing: {{keywords}}",
                "overusedKeywordsTitle": "Overused Keywords",
                "overusedKeywordsDesc": "Overused: {{keywords}}",
                "analysisCompleteTitle": "Analysis complete"
            },
            "mockPlan": {
                "task1Title": "Optimize CV + Update LinkedIn",
                "task1Subtitle": "Completed on April 11",
                "task2Title": "Define objective + save 10 jobs",
                "task2Subtitle": "Completed on April 12",
                "task3Title": "Apply to 5-10 roles strategically",
                "task3Subtitle": "Today - Use your optimized CV",
                "task4Title": "Connect with 10 recruiters on LinkedIn",
                "task4Subtitle": "Next step",
                "task5Title": "Interview preparation (STAR method)",
                "task5Subtitle": "Upcoming"
            },
            "mockApplications": {
                "followUpIn4Days": "Follow up in 4 days",
                "none": "–"
            }
        },
        "emptyState": {
            "title": "Upload a CV to see your scores",
            "body": "A new account starts at 0. Upload your CV so we can analyze it and show real match data.",
            "cta": "Go to My CVs to upload →"
        }
    },
    "landing": {
        "helpImprove": {
            "ariaLabel": "Help us improve",
            "eyebrow": "Help us improve",
            "titleBefore": "Get an extra CV optimization",
            "titleAccent": "for free",
            "ratingLabel": "1. Overall Rating",
            "ratingHint": "How would you rate your experience?",
            "ratingAria": "Overall rating",
            "starAria": "{{star}} out of 5 stars",
            "ratingCaption": "Click a star to rate",
            "feedbackLabel": "2. Your feedback",
            "feedbackHint": "What did you like? What could be better?",
            "improvementLabel": "3. Did you notice any improvements after using HireFit?",
            "improvementYes": "Yes",
            "improvementNo": "No",
            "improvementNotSure": "Not sure yet",
            "emailLabel": "4. Email Address",
            "emailHint": "Where should we send your free CV optimization?",
            "emailCaption": "We will only use this to send your free optimization.",
            "submit": "Submit & Get My Free Optimization →",
            "note": "We read every response. Your feedback directly shapes how we improve HireFit.",
            "limit": "Available to Core, Pro and Premium users. We'll add one extra CV optimization to your current plan.",
            "thanks": "Thanks — we received your feedback. We'll be in touch about your free CV optimization.",
            "errors": {
                "rating": "Please choose a star rating.",
                "feedback": "Please tell us what you liked or what could be better.",
                "improvement": "Please choose whether you noticed improvements.",
                "email": "Please enter a valid email address."
            }
        },
        "hero": {
            "eyebrow": "Your next job starts here.",
            "title": "Be HireFit.",
            "subtitle": "We make your profile impossible to ignore.",
            "description1": "Your CV is competing against 250 others, and 75% get rejected in under 6 seconds.",
            "description1Strong": "Without ever reaching a human.",
            "description2": "tells you exactly why yours is failing, rewrites it with the language recruiters actually respond to, and delivers a CV that gets interviews in under 3 minutes. Stop sending CVs that get ignored.",
            "cta": "Get my CV hire-ready",
            "featureAnalysis": "Instant AI analysis",
            "featureOptimization": "5-minute optimization",
            "featureKeywords": "Keyword optimization"
        },
        "problem": {
            "eyebrow": "THE PROBLEM",
            "titleBefore": "Your CV isn't failing because",
            "titleHighlight": "you're not qualified.",
            "subtitle": "It's failing because you're not speaking the right language for the market you're",
            "subtitleStrong": "targeting.",
            "footnote": "We help you avoid these and many other mistakes.",
            "stats": {
                "ats": {
                    "stat": "78%",
                    "titleStart": "Get rejected before",
                    "titleHighlight": "human review",
                    "description": "ATS software filters out most CVs automatically, before a single recruiter sees them."
                },
                "seconds": {
                    "stat": "6 sec",
                    "titleStart": "",
                    "titleHighlight": "Is all you get",
                    "description": "When your CV does reach a recruiter, you have 6 seconds to communicate your value. A well-structured CV does this, but most people get it wrong."
                },
                "results": {
                    "stat": "3 of 4",
                    "titleStart": "CVs list responsibilities,",
                    "titleHighlight": "not results",
                    "description": "Recruiters want measurable achievements. For example, “Managed a team” doesn’t get interviews. “Led a team of _, increased output by _%” does."
                }
            }
        },
        "ctaBanner": {
            "headlineBlue": "Stop missing out",
            "headlineDark1": "on interviews because",
            "headlineDark2": "of simple CV mistakes",
            "link": "Try our free CV review!"
        },
        "banner": {
            "phrase1": "YOUR NEXT CHAPTER STARTS NOW.",
            "phrase2": "THE RIGHT OPPORTUNITY WILL FIND YOU.",
            "phrase3": "THE RIGHT ROLE IS OUT THERE."
        },
        "howItWorks": {
            "eyebrow": "YOUR SOLUTION TO",
            "title": "Get hired",
            "subtitle": "IN 4 SIMPLE STEPS",
            "tagline": "From profile upload to job offers in minutes, not months!",
            "steps": {
                "upload": {
                    "title": "Upload your profile",
                    "description": "Upload your CV or connect your LinkedIn profile in seconds."
                },
                "analysis": {
                    "title": "AI analysis",
                    "description": "Our AI analyzes your profile against thousands of successful candidates."
                },
                "recommendations": {
                    "title": "Get recommendations",
                    "description": "Receive detailed, actionable feedback on how to improve your profile score."
                },
                "apply": {
                    "title": "Download & apply",
                    "description": "Export your optimized profile and start getting noticed by top recruiters."
                }
            }
        },
        "howWeFixIt": {
            "eyebrow": "HOW WE FIX IT",
            "title1": "With powerful tools and insights we created to transform",
            "title2": "your profile into a recruiter magnet",
            "ats": {
                "title": "ATS optimization",
                "description": "Get past applicant tracking systems with AI-powered keyword optimization and formatting."
            },
            "feedback": {
                "title": "Instant feedback",
                "description": "Real-time analysis of your profile with actionable suggestions to improve your score."
            },
            "privacy": {
                "title": "Privacy first",
                "description": "Your data stays secure and private. We never share your information with third parties."
            },
            "growth": {
                "title": "Career growth",
                "description": "Track your profile improvement over time and measure your job-readiness score."
            }
        },
        "impossibleCta": {
            "lead": "Are you ready to become",
            "highlight": "impossible",
            "tail": "to ignore?!",
            "sub": "Join other job seekers who've transformed their careers with",
            "checkResults": "Instant results",
            "checkSecure": "Secure & private",
            "checkAts": "ATS-optimized output"
        },
        "pricing": {
            "yourPlanEyebrow": "YOUR PLAN",
            "youreOn": "You're on",
            "bestPlanSubtitle": "Congratulations — you already have HireFit's best plan.",
            "upgradeEyebrow": "UPGRADE",
            "chooseYour": "Choose your",
            "nextPlan": "next plan",
            "upgradeSubtitle": "You're on {{plan}}. Pick a higher tier to unlock more.",
            "joinEyebrow": "JOIN US",
            "perfectPlan": "perfect plan",
            "joinSubtitle": "One-time payments. No subscriptions. No tricks.",
            "loading": "Loading your plan options…",
            "currentPlanAria": "Current plan",
            "congratulations": "Congratulations!",
            "bestPlanMessage": "You're on the best plan HireFit offers. Enjoy full access to every feature.",
            "startingCheckout": "Starting checkout…",
            "featuresAria": "{{plan}} features",
            "footnote": "All plans include secure data handling and privacy protection.",
            "suffixForever": "/ forever",
            "suffixOneTime": "/ one-time",
            "access": "{{days}} days of access",
            "linkedin": "LinkedIn optimization",
            "quota": {
                "perLicense": "{{analyses}} CV analyses + {{complete}} complete analyses ({{days}}-day license)",
                "perDay": "{{analyses}} CV analysis + {{complete}} complete analysis per day ({{analysesTotal}} + {{completeTotal}} over {{days}} days)"
            },
            "errors": {
                "signIn": "Sign in to purchase a plan.",
                "serviceUnavailable": "Payment service is unavailable. Please try again later.",
                "checkoutFailed": "Failed to start checkout."
            },
            "plans": {
                "free": {
                    "description": "Perfect for trying out HireFit",
                    "cta": "Get started for free",
                    "f1": "Hire Probability Score",
                    "f2": "4 dimension scores (ATS, Impact, Clarity, Role Fit)",
                    "f3": "Top error detected",
                    "f4": "Full optimized CV",
                    "f5": "Action plan and outreach"
                },
                "core": {
                    "tier": "GET INTERVIEWS",
                    "description": "Your CV, fully optimized",
                    "cta": "Get Core",
                    "f1": "Everything in Free, resolved",
                    "f2": "ATS-safe PDF",
                    "f3": "Skills gap analysis",
                    "f4": "Error explanations",
                    "f5": "Career paths and 7-day plan"
                },
                "pro": {
                    "tier": "STRATEGIC POSITIONING",
                    "description": "The complete hiring system",
                    "cta": "Start optimizing",
                    "badge": "MOST POPULAR",
                    "f1": "Everything in Core, plus:",
                    "f2": "Career paths (3–4 roles)",
                    "f3": "7-day action plan",
                    "f4": "Cold outreach messages"
                },
                "premium": {
                    "tier": "COMPLETE POSITIONING",
                    "description": "Everything a recruiter sees, optimized",
                    "cta": "Get Premium",
                    "f1": "Everything in Pro, plus:",
                    "f2": "LinkedIn headline rewrite",
                    "f3": "LinkedIn About section rewrite",
                    "f4": "LinkedIn experience rewrite",
                    "f5": "LinkedIn banner (2 options)",
                    "f6": "CV score guaranteed 85+"
                }
            }
        }
    },
    "checkout": {
        "eyebrow": "HireFit Checkout",
        "opening": "Opening secure checkout…",
        "sandboxNote": "Sandbox mode — use Paddle test cards only.",
        "unavailable": "Checkout unavailable",
        "backToPricing": "Back to pricing",
        "success": "Payment successful",
        "successMessage": "Your license is active. Redirecting to your dashboard…",
        "activationIssue": "Activation issue",
        "complete": "Complete your purchase",
        "completeMessage": "If the Paddle overlay didn't appear, refresh this page or return to pricing and try again.",
        "errors": {
            "noSession": "No checkout session found. Choose a plan from pricing to continue.",
            "loadFailed": "Unable to load Paddle checkout.",
            "failed": "Checkout failed. Please try again."
        }
    }
}
